import { Injectable } from '@angular/core';
import { ChatCompletionMessageParam } from 'openai/resources/index.mjs';
import { Story } from '../Story';
import { AIMessage } from '@meta-press/shared-plugins';



@Injectable({
  providedIn: 'root'
})
export class StoryService {

  // Map with number as key and ChatCompletionMessageParam[] as value
  private stories: Map<number, Story> = new Map();
  
  GetPreviousMessages(storyID: number): AIMessage[] | undefined {
    console.log("Getting previous messages for storyID: " + storyID);
    console.log(this.stories.get(storyID));
    const story = this.stories.get(storyID);
    
    if (story) return story.messages;
    else return undefined;
  }
  
  public GetFreeStoryID(): number {
    let storyID = 0;
    
    while (this.stories.has(storyID)) {
      storyID = storyID + 1;
    };
    
    return storyID;
  }
  
  public GetStory(storyID: number): Story | undefined {
    return this.stories.get(storyID);
  }
  
  public CreateStory(storyID = -1): Story | undefined {
    if (storyID == -1) {
      const newID = this.GetFreeStoryID();
      const story = new Story(newID);
      this.stories.set(story.storyID, story);
      return story;
    }
    if (!this.stories.has(storyID)) {
      const newStory = new Story(storyID);
      this.stories.set(storyID, newStory);
      
      return newStory;
    } else {
      return this.stories.get(storyID);
    }
  }
  
  AddMessage(storyID: number, message: AIMessage): void {
    let story = this.stories.get(storyID);
    
    if (story === undefined) story = this.CreateStory(storyID);

    if (story) {
      story.messages.push(message);

      // this.stories.set(storyID, messages);
      console.log("Previous messages is now " + this.stories.get(storyID));  
    } else {
      console.warn("Couldn't add messages to " +storyID + " because it doesn't exist");
    }
  }
  
  AddUserInput(storyID: number, input: string) {
    let story = this.stories.get(storyID);
    
    if (story === undefined) story = this.CreateStory(storyID);

    if (story) {
      story.messages.push({ role: "user", content: input } as AIMessage);

      // this.stories.set(storyID, messages);

      console.log("Previous messages is now " + this.stories.get(storyID));  
    }
    
  }
}
